<template lang="pug">
  .height-100(v-if="lista.length > 1")
    h3.title Funciones
    p
    div.contenedor-box
      .box.position-relative
        .lista-solicitud-vacaciones.contenedor-interno
          .title
            span Mis Funciones y de mi equipo

          .body
            transition-group.contenedor-transition(name="fade-smooth-two", tag="div")
              .mensaje-informacion(key="mensaje_no_solicitudes", v-if="!isLoading && lista.length === 0")
                .message.is-info
                  .message-body
                    span No hay funciones
              .is-desktop(key="div-table-solicitud-por-aprobar")
                table.table.is-striped.is-bordered(key="table-solicitud-por-aprobar", v-if="lista.length > 0")
                  thead
                    th Codigo
                    th Empleado
                    th DNI
                    th Cargo
                    th Acciones
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="o in lista"
                      :class="{'row-info': o.isme}"
                      :key="o.codigo + 'id'"
                    )
                      td {{ o.codigo }}
                      td {{ o.nombre }}
                      td {{ o.dni }}
                      td {{ o.cargo }}
                      td.text-center
                        template(v-if="o.pathPdf")
                          a.button.is-small(@click="verAdjunto(o.pathPdf)")
                            span.icon.is-small
                              i.fa.fa-paperclip.is-small.fs-12
                            span Ver adjunto
                        template(v-else)
                          span.no-accion Sin adjunto
              .is-mobile(key="div-card-solicitud-por-aprobar")
                .box(
                  v-for="(o, index) in lista"
                  :class="{'row-info': o.isme}"
                  :key="o.id + 'id'"
                )
                  .empleado.hint--right(:aria-label="'Solicitud: ' + o.id")
                    span.hint--bottom(:aria-label="'Empleado: ' + o.dni")
                      | {{ o.nombre }}
                  .descripcion-tipo
                    span {{ o.cargo }}
                  .motivo
                    span {{ o.cargo }}
                  .botones
                    template(v-if="o.pathPdf")
                      a.button.is-small(:href="o.pathPdf", target="_blank")
                        span.icon.is-small
                              i.fa.fa-paperclip.is-small.fs-12
                        span Ver adjunto
            loading(v-if="isLoading")
  .height-100(v-else)
    h3.title Mis Funciones
    p
    template(v-if="!isLoading")
      iframe(:src="path")
        | Oops! an error has occurred.
</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'mis-funciones',
  data () {
    return {
      path: '',
      isLoading: true,
      lista: []
    }
  },
  watch : {
  },
  created () {
    this.obtenerFuncion()
  },
  methods: {
    obtenerFuncion () {
      var vm = this
      vm.isLoading = true
      var obj = {
        empresa: process.env.EMPRESA,
        codigo: localStorage.getItem('codigo')
      }
      apiGet(vm, '/funciones_pdf/obtener/funcion', obj, function (data) {
        if (data.lista.length === 1) {
          vm.path = data.lista[0].pathPdf
          if (!vm.path.startsWith('http')) {
            vm.path = process.env.API_ROUTE + '/funciones_pdf/mostrarPath?ruta=' + vm.path
          }
        } else {
          for (var i = 0; i < data.lista.length; i++) {
            if (+data.lista[i].codigo === +localStorage.getItem('codigo')) data.lista[i].isme = true
            else data.lista[i].isme = false
            vm.lista.push(data.lista[i])
          }
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    verAdjunto (pdf) {
      var url = process.env.API_ROUTE + '/funciones_pdf/mostrarPath?ruta=' + pdf
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="stylus" scoped>
.height-100
  height 100%
  min-height 100%
iframe
  width 100%
  height: calc(100vh - 150px);
.ta-center
  text-align center
.contenedor-interno
  .close
    position absolute
    top 3px
    right 3px
    float right
    cursor pointer
    i
      font-size 16px

  .title
    font-size 16px
    span
      font-weight bold
      text-transform uppercase

th
  text-align center



.row-table
  transition all 0.3s ease
  &.is-close
    background-color #ffd6d6 !important


.table-row-enter, .table-row-leave-active {
  opacity: 0
  height 0
}

.position-relative
  position relative

.quitar
  margin-left 5px
  cursor pointer
  i
    font-size 15px

.dias-pedidos
  font-size 12px
  color #9a9a9a

// .fs-12
//   font-size 12px

td
  vertical-align: middle;
  .contenedor-acciones
    padding-top 4px
    display flex
    .button
      flex 1
      margin 0px 5px
td.text-center
  span.no-accion
    font-size: 12px

.mensaje-informacion
  margin-bottom 10px


.contenedor-transition
  display flex
  justify-content center
  flex-direction column
  position relative
  >*
    transition all .5s
    width 100%

.is-mobile
  display none
  .box
    position: relative;
  .status
    position:absolute;
    top: -3px
    right: 5px
    span {
      font-size: 10px;
      color #a5a5a5
      font-weight: bold;
    }
  .descripcion-tipo
    margin-bottom 5px
    margin-top: 15px
  .motivo
    background-color: #eff5fb;
    color: #296fa8;
    padding: 10px
  .botones
    display flex
    justify-content center
    margin-top 10px
    .button
      margin-right 5px
      &:last-child
        margin-right 0px
  .checkbox
    position: absolute;
    top: 10px;
    left: 12px;
    margin-bottom: 1px;
    input
      transform: scale(1.5);
  .empleado
    position absolute
    top 4px
    right 8px
    // right:  8px
    margin-bottom 1px
    .bold
      font-weight bold
  .codigo
    position absolute
    top 4px
    left 8px
    font-weight: bold;
    color #296fa8

@media (max-width 660px)
  .is-mobile
    display block

  .is-desktop
    display none
.contenedor-box
  display flex
  justify-content center
  flex-direction column
  position relative
  >*
    transition all .5s
    width 100%
</style>




// WEBPACK FOOTER //
// View_Mis_Funciones.vue?5b010350